<template>
  <div class="loader" :style="{color: color, textShadow: shadow}">
    <i class="fa fa-spinner fa-pulse"></i>
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    message: {
      type: String,
      default: 'Loading',
    },
    color: {
      type: String,
      default: '#ccc',
    },
    shadow: {
      type: String,
      default: '2px 2px 2px #efefef',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.loader {
  text-align: center;
  font-size: 1.6em;
}

.loader .fa {
  font-size: 2.2em;
  margin-top: 30px;
  margin-bottom: 15px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// Loader.vue?42aa3ab4